<template>
	<f7-page name="ccm-code-study" class="page-bg-render">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">
				학습코드로 학습
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
			</f7-nav-right>
		</f7-navbar>
		<f7-block-title>학습코드 입력</f7-block-title>
		<div class="list no-hairlines-between">
			<ul>
				<li>
					<div class="item-content item-input item-input-outline">
						<div class="item-inner">
							<div class="item-title item-floating-label">학습코드</div>
							<div class="item-input-wrap">
								<input type="text" ref="code" :value="code.toUpperCase()" @input="code = $event.target.value.toUpperCase()" v-on:keyup.enter="onEnterKey">
								<span class="input-clear-button"></span>
							</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<button class="button button-fill" v-on:click="startCodeSelfStudy">학습 콘텐츠 보기</button>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<f7-block-title>코드 학습 내역</f7-block-title>
		<div class="list">
			<ul>
				<template v-for="(item, i) in studyList">
					<li v-if="isNewGroup(item, i)" :key="'gi' + i" class="list-group-title" style="height:30px; font-size:14px;">{{dateDisplay(item)}}</li>
					<li :key="'ii' + i">
						<!--
						<a href="#" class="item-link margin-right" v-on:click="launchContents(item)">
							<div class="item-content item-media">
								<i class="f7-icons text-color-purple">
									{{getIconName(item.LECTURE_TYPE)}}																			
								</i>							  													
								<span>{{item.CODE}}</span>
							</div>
							<div class="item-inner">
								<div class="item-title">{{item.STUDY_NAME}}</div>
							</div>
						</a>
						-->
						<a href="#" class="item-link item-content" v-on:click="launchContents(item)">
							<div class="item-media">
								<i class="f7-icons text-color-purple">
									{{getIconName(item.LECTURE_TYPE)}}																			
								</i>
							</div>
							<div class="item-inner">
								<div class="item-title">{{item.STUDY_NAME}}</div>
								<div class="item-after">{{item.CODE}}</div>
							</div>
						</a>
					</li>
				</template>
			</ul>
		</div>


		<div class="sheet-modal sheet-modal-top lectures-modal" style="height:auto;">
			<div class="toolbar toolbar-bottom">
				<div class="toolbar-inner">
					<div class="left"></div>
					<div class="right"><a class="link sheet-close text-color-primary" href="#">닫기</a></div>
				</div>
			</div>
			<div class="sheet-modal-inner">
				<div class="block">
					<template v-if="hintContents.length > 0">
						<h2 class="text-align-center">힌트 컨텐츠</h2>
						<div class="text-align-center">
							<template v-for="(lecture, i) in hintContents">
								<a class="text-color-primary margin-right" :key="'i' + i" style="white-space: nowrap;" v-on:click="onLaunchHintContents($event, i)">
									<i class="f7-icons text-color-purple" style="vertical-align: text-bottom;">{{getIconName(lecture.LECTURE_TYPE)}}</i>
									<span>{{getLevelName(lecture.LECTURE_LEVEL)}}</span>
								</a>
							</template>
						</div>
					</template>
					<template v-if="lectureContents.length > 0">
						<h2 class="text-align-center">강의 컨텐츠</h2>
						<div class="text-align-center">
							<template v-for="(lecture, i) in lectureContents">
								<a class="text-color-primary margin-right" :key="'i' + i" style="white-space: nowrap;" v-on:click="onLaunchLectureContents($event, i)">
									<i class="f7-icons text-color-purple" style="vertical-align: text-bottom;">{{getIconName(lecture.LECTURE_TYPE)}}</i>
									<span>{{getLevelName(lecture.LECTURE_LEVEL)}}</span>
								</a>
							</template>
						</div>
					</template>
					<template v-if="hintContents.length == 0 && lectureContents.length == 0">
						<h2 class="text-align-center">학습 컨텐츠</h2>
						<div class="text-align-center">
							<span>지원되는 학습 컨텐츠가 없습니다.</span>
						</div>
					</template>
				</div>
				<div class="block" style="height:var(--f7-toolbar-height);">&nbsp;<!-- 툴바만큼 height 확보 --></div>
			</div>
		</div>
		
	</f7-page>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import { f7 } from 'framework7-vue';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth';

export default {
	data() {
		return {
			lastLaunchContents: {
				code: "",
				lectures: []
			},
			code: "",
			hintContents: [],
			lectureContents: [],
			studyList: [],

			sheet: undefined
		}
	},
	mounted() {
		this.loadCodeSelfStudyList();
	},
	methods: {
		isNewGroup(item, i) {
			if (i > 0) {
				var prevItem = this.studyList[i-1];
				var prevItemWriteDate = moment(prevItem.WRITE_DATETIME);

				var currItem = item;
				var currItemWriteDate = moment(currItem.WRITE_DATETIME);

				if (currItemWriteDate.isSame(prevItemWriteDate, 'd')) {
					return false;
				}
			}

			return true;
		},
		dateDisplay(item) {
			var dateName = MODULE.Util.datediff(item.WRITE_DATETIME);
			var dateFormat = moment(item.WRITE_DATETIME).format("YYYY-MM-DD");

			return dateName + " (" + dateFormat + ")";
		},
		showSheetModal() {
			// sheet 는 열때마다 생성, 닫을때 제거해야 정상 동작 한다.

			if (this.sheet == undefined) {
				this.sheet = f7.sheet.create({
					el: '.lectures-modal',
					swipeToClose: false,
					swipeToStep: false,
					backdrop: true
				});
			}
			
			this.sheet.open();
		},
		onEnterKey() {
			this.startCodeSelfStudy();
		},
		getIconName(lectureType) {
			if (lectureType == "c-otl" || lectureType == "e-otl") {
				return "arrowtriangle_right_circle";
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				return "videocam_circle"
			} else if (lectureType == "c-img" || lectureType == "e-img") {
				return "photo";
			} else {
				return "question";
			}
		},
		getLevelName(lectureLevel) {
			return CONST.lectureLevelMap[lectureLevel].name;
		},
		splitLectures(lectures) {
			var hintContents = [];
			var lectureContents = [];

			for (var i=0; i<lectures.length; i++) {
				var lecture = lectures[i];

				if (lecture.BLOCK_ORDER <= 10) {
					hintContents.push(lecture);
				} else {
					lectureContents.push(lecture);
				}
			}

			this.hintContents = hintContents;
			this.lectureContents = lectureContents;
    },
    loadCodeSelfStudyList() {
      var _this = this;

      var startDate = moment().add(-2, "days").format("YYYY-MM-DD");
      var endDate = moment().format("YYYY-MM-DD");


			let param = {
        pStartDate : startDate,
        pEndDate : endDate
			};

			API.ajaxRequest({
				url: API.getCodeSelfStudyListUrl(),
				data: param
			}).then(function (data) {

				_this.studyList = data.studyList;

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		startLinkExamSelfStudy() {
			var _this = this;

			if (_this.lastLaunchContents.code == _this.code) {
				if (_this.lastLaunchContents.lectures.length == 1) {
					var lecture = _this.lastLaunchContents.lectures[0];
					_this.launchContents(lecture);
				} else if (_this.lastLaunchContents.lectures.length > 1) {
					_this.splitLectures(_this.lastLaunchContents.lectures);
					_this.showSheetModal();
				}

				return;
			}

			var linkExamKey = MODULE.Util.codeToKey(CONST.linkExamCodePrefix, _this.code);
			if (linkExamKey <= 0) {
				MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
				return;
			}

			let param = {
				pLinkExamKey : linkExamKey
			};

			API.ajaxRequest({
				url: API.linkExamContentsUrl(),
				data: param
			}).then(function (data) {

				_this.lastLaunchContents.code = _this.code;
				_this.lastLaunchContents.lectures = data.lectures;

				if (data.lectures.length == 1) {
					var lecture = data.lectures[0];
					_this.launchContents(lecture);
				} else if (data.lectures.length > 1) {
					_this.splitLectures(data.lectures);
					_this.showSheetModal();
				}
			}).catch(function (code) {
				if (code == CONST.resultCode.EMPTY) {
					MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다.<br/>코드를 확인하세요.");
				}

				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		startLectureSelfStudy() {
			var _this = this;

			if (_this.lastLaunchContents.code == _this.code) {
				if (_this.lastLaunchContents.lectures.length == 1) {
					var lecture = _this.lastLaunchContents.lectures[0];
					_this.launchContents(lecture);
				}

				return;
			}

			var lectureKey = MODULE.Util.codeToKey(CONST.lectureCodePrefix, _this.code);
			if (lectureKey <= 0) {
				MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
				return;
			}

			let param = {
				pLectureKey : lectureKey
			};

			API.ajaxRequest({
				url: API.lectureContentsUrl(),
				data: param
			}).then(function (data) {

				_this.lastLaunchContents.code = _this.code;
				_this.lastLaunchContents.lectures = data.lectures;

				if (data.lectures.length == 1) {
					var lecture = data.lectures[0];
					_this.launchContents(lecture);
				} else if (data.lectures.length > 1) {
					_this.splitLectures(data.lectures);
					_this.showSheetModal();
				}
			}).catch(function (code) {
				if (code == CONST.resultCode.EMPTY) {
					MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다.<br/>코드를 확인하세요.");
				}

				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		startCodeSelfStudy() {
			var _this = this;

			if (MODULE.Util.isEmpty(_this.code)) {
				MODULE.DialogBox.message("코드를 입력하세요.");
				return;
			}

			var prefix = MODULE.Util.codePrefix(_this.code);
      if (prefix == CONST.linkExamCodePrefix) {
        _this.startLinkExamSelfStudy();
      } else if (prefix == CONST.examSetCodePrefix) {
        MODULE.DialogBox.message("에러", "학습코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.lectureCodePrefix) {
				_this.startLectureSelfStudy();
      } else if (prefix == CONST.matchPaperCodePrefix) {
        MODULE.DialogBox.message("에러", "학습코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.matchBookCodePrefix) {
        MODULE.DialogBox.message("에러", "학습코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.smartBookCodePrefix) {
        MODULE.DialogBox.message("에러", "학습코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else if (prefix == CONST.pqatCodePrefix) {
        MODULE.DialogBox.message("에러", "학습코드가 아닙니다.<br/>코드를 확인하세요.");
        return;
      } else {
        MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
        return;
      }

			this.$refs.code.focus();
		},
		saveLinkExamSelfStudy(lecture) {
			var _this = this;

			var lectureType = lecture.LECTURE_TYPE;
			var lectureCode = lecture.LECTURE_CODE;
			
			var linkExamKey = MODULE.Util.codeToKey(CONST.linkExamCodePrefix, this.code);
			var lectureKey = MODULE.Util.codeToKey(CONST.lectureCodePrefix, lectureCode);

			if (linkExamKey <= 0 || lectureKey <= 0) {
				MODULE.DialogBox.message("학습 코드가 잘못되어 실행할 수 없습니다.");
				return;
			}

			let param = {
				pStudyType : _this.studyType,
				pLinkExamKey : linkExamKey,
				pLectureKey : lectureKey
			};

			API.ajaxRequest({
				url: API.saveLinkExamSelfStudyUrl(),
				data: param
			}).then(function (data) {

				_this.loadCodeSelfStudyList();
				_this.launchContents(lecture);
				
			}).catch(function (code) {
				if (code == CONST.resultCode.EMPTY) {
					MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다.<br/>코드를 확인하세요.");
				}

				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		launchContents(lecture) {
			var lectureType = lecture.LECTURE_TYPE;
			var lectureCode = lecture.LECTURE_CODE;
			lectureCode = "NCL";

			if (lectureType == "c-img" || lectureType == "e-img") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-otl" || lectureType == "e-otl") {
				const accessToken = AUTH.getAccessToken();
				MODULE.Util.appCall(accessToken, "show.otl", "lcode", lectureCode);
			}
	
		},
		onLaunchHintContents(e, index) {
			var lecture = this.hintContents[index];
			this.saveLinkExamSelfStudy(lecture);
		},
		onLaunchLectureContents(e, index) {
			var lecture = this.lectureContents[index];
			this.saveLinkExamSelfStudy(lecture);
		},
	}
}
</script>